import { render, staticRenderFns } from "./ButtonNotation.vue?vue&type=template&id=4b41ed3a&"
import script from "./ButtonNotation.vue?vue&type=script&lang=js&"
export * from "./ButtonNotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports